export default {
  route: 'organisationseinheit',
  fields: [
    {
      label: 'Name',
      field: 'name',
      type: 'string'
    },
    {
      label: 'Kostenstelle',
      field: 'kostenstelle',
      type: 'string'
    }
    // {
    //   label: 'Übergeordnete Organisationseinheit',
    //   cardinality: 'single',
    //   field: 'ueberOrganisationseinheit',
    //   type: 'object',
    //   schema: {
    //     route: 'organisationseinheit',
    //     fields: [
    //       {
    //         label: 'Name',
    //         field: 'name'
    //       },
    //       {
    //         label: 'Kostenstelle',
    //         field: 'kostenstelle'
    //       }
    //     ]
    //   },
    //   nested: false
    // }
  ]
}



// WEBPACK FOOTER //
// ./src/schema/Parent.js